module.exports = __webpack_public_path__ + "static/media/green-tick.9bdbbe43.png";